import { scorT } from 'i18n/scorLocale';

export const hasScorUploadRules = (rules?: ApiScorUploadRules): rules is ApiScorUploadRules => Boolean(
  rules?.field && Number.isInteger(rules.max_files) && rules.max_files > 0 &&
  Number.isInteger(rules.max_size_bytes) && rules.max_size_bytes > 0 &&
  rules.extensions?.length && rules.accept
);

export const validateScorFiles = (files: File[], rules?: ApiScorUploadRules, required = true): string | undefined => {
  if (!hasScorUploadRules(rules)) return scorT('unableToLoadUploadSettingsPleaseReload');
  if (required && files.length === 0) return scorT('addAtLeastOneDocument');
  if (files.length > rules.max_files) return scorT('youCanAttachUpToFiles', { v0: rules.max_files });
  const oversized = files.find((file) => file.size > rules.max_size_bytes);
  if (oversized) return scorT('theFileExceeds', { v0: oversized.name, v1: rules.max_size_mb ? scorT('mb', { v0: rules.max_size_mb }) : scorT('bytes', { v0: rules.max_size_bytes }) });
  const invalid = files.find((file) => !file.name.includes('.') || !rules.extensions.includes(file.name.split('.').pop()?.toLowerCase() ?? ''));
  if (invalid) return scorT('unsupportedFileFormat', { v0: invalid.name });

  return undefined;
};

export const normalizeScorOrders = (orders: ApiScorOrder[]): ApiScorOrder[] => {
  const result = new Map<string, ApiScorOrder>();
  orders.forEach((order, index) => {
    const key = order.request_id != null ? `request-${order.request_id}` : order.id != null ? `order-${order.id}` : `unknown-${index}`;
    const previous = result.get(key);
    if (!previous?.id || order.id) result.set(key, order);
  });

  return Array.from(result.values());
};

export const hasScorOutcome = (report: ApiScorPoolReportItem): boolean => Boolean(report.outcome?.actual?.trim());
